export default "__VITE_ASSET__Czoa9v22__"